export default __webpack_public_path__ + "static/media/04.1fe8f6c0.jpg";